import axios from 'axios'
import { Message } from 'element-ui'
import store from '../store'
import businessErrorHandler from './businessErrorHandler'

// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_API,
  timeout: 30000
})
// request拦截器
service.interceptors.request.use(config => {
  if (store.getters.token) { config.headers['fhSessionId'] = store.getters.token }
  if (store.getters.permissionToken) { config.headers['permissionId'] = store.getters.permissionToken }
  return config
}, error => {
  return Promise.reject(error)
})
// response拦截器
service.interceptors.response.use(
  response => {
    let res = response.data
    if (res.status !== '10000') {
      return businessErrorHandler(res)
    } else {
      return response.data
    }
  },
  error => {
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求错误'
          break
        case 401:
          error.message = '未授权，请登录'
          break
        case 403:
          error.message = '拒绝访问'
          break
        case 404:
          error.message = `请求地址出错: ${error.response.config.url}`
          break
        case 408:
          error.message = '请求超时'
          break
        case 500:
          error.message = '服务器内部错误'
          break
        case 501:
          error.message = '服务未实现'
          break
        case 502:
          error.message = '网关错误'
          break
        case 503:
          error.message = '服务不可用'
          break
        case 504:
          error.message = '网关超时'
          break
        case 505:
          error.message = 'HTTP版本不受支持'
          break
        default:
      }
    }
    Message({
      message: error.message,
      type: 'error',
      duration: 2 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/fetch.js